import { ACTION_TYPES } from "./ProfitLossAction";

const initialState = {
    isLoading: false,
    profitLossData: [],
    error: null,
};

const ProfitLossReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.REQUEST:
            return { ...state, isLoading: true, error: null };
        case ACTION_TYPES.SUCCESS:
            return { ...state, isLoading: false, profitLossData: action.payload };
        case ACTION_TYPES.ERROR:
            return { ...state, isLoading: false, error: action.payload };
        default:
            return state;
    }
};

export default ProfitLossReducer;
